import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-electronic-billing-actions',
  templateUrl: './electronic-billing-actions.component.html',
  styleUrls: ['./electronic-billing-actions.component.scss'],
})
export class ElectronicBillingActionsComponent implements OnInit {
  value: any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  emailCheck = true;

  ngOnInit(): void {
    const dto = {
      action: this.value.action,
      emailCopy: this.emailCheck,
    };
    this.change.emit(dto);
  }

  checkboxChange($event: any) {
    this.emailCheck = $event;
    const dto = {
      action: this.value.action,
      emailCopy: this.emailCheck,
    };
    this.change.emit(dto);
  }
}
